import React from "react";
import { Route, Switch } from "react-router";
import Overview from "./Overview";
import Discount from "./Discount";

class MainPanel extends React.Component {
  render() {
    return (
      <Switch>
        <Route component={Overview} />
      </Switch>
    );
  }
}

export default MainPanel;



// WEBPACK FOOTER //
// src/layout/Dashboard/MainPanel/index.js